export default class PoliticaBancoHora {
    constructor() {
        this.id = null;        
        this.descricao = null;       
        this.periodoInicial = null;       
        this.periodoFinal = null;              
        this.bancoHoraArmazenamento = null;
        this.bancoHoraTransferencia = null;       
    }    
}